









































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import HoverDescription from '@/components/atoms/HoverDescription.vue';
import AnnouncementDialogDetail from '@/components/molecules/AnnouncementDialogDetail.vue';
import { CaptionCollection } from '@/components/organisms/PortalAnnouncementsPanel.vue';
import { commonModule } from '@/store/modules/CommonStore';
import {
  LoginInfo,
  UserAnnouncement,
  UpdateUserAnnouncementQueryParam,
} from '@/types/type';

@Component({ components: { HoverDescription, AnnouncementDialogDetail } })
export default class AnnouncementLink extends Vue {
  private loginInfo: LoginInfo = commonModule.loginInfo;
  private dialog: boolean = false;

  @Prop()
  private userAnnouncement!: UserAnnouncement;

  @Prop()
  private captionCollection!: CaptionCollection;

  private get announcement(): UserAnnouncement {
    return this.userAnnouncement;
  }

  private get readCss(): string {
    return this.userAnnouncement.isRead ? 'isReadCss' : 'unReadCss';
  }

  @Emit('button-link-opened')
  private confirmAnnouncement(): UpdateUserAnnouncementQueryParam | null {
    if (!this.userAnnouncement.isRead) {
      this.userAnnouncement.isRead = true;
      return {
        announcementId: this.userAnnouncement.id,
        displayStartDate: this.userAnnouncement.displayStartDateAsUpdateParam,
      };
    }
    return null;
  }

  private closeDialog(): void {
    this.dialog = false;
  }
}
